import request from '@/utils/request'

let BASEROOT          = '/visitor/v2'

// LinkedIn获取用户信息
export function getLinkedInUserInfo(data) {
  return request({
    url: BASEROOT + '/account/platform/getLinkedInUserInfo',
    method: 'post',
    data
  })
}